// Mirrors backend controllers/act/actSlotValidation.js so the UI can give
// instant feedback before hitting the API. The backend remains the source of truth.

export function toMinutes(timeStr) {
    if (!timeStr) return null;
    const trimmed = timeStr.trim();

    const twelveHourMatch = trimmed.match(/^(\d{1,2}):(\d{2})\s*([AaPp][Mm])$/);
    if (twelveHourMatch) {
        let [, h, m, meridian] = twelveHourMatch;
        h = parseInt(h, 10);
        m = parseInt(m, 10);
        meridian = meridian.toUpperCase();
        if (meridian === 'AM') {
            if (h === 12) h = 0;
        } else if (h !== 12) {
            h += 12;
        }
        return h * 60 + m;
    }

    const twentyFourMatch = trimmed.match(/^(\d{1,2}):(\d{2})$/);
    if (twentyFourMatch) {
        return parseInt(twentyFourMatch[1], 10) * 60 + parseInt(twentyFourMatch[2], 10);
    }

    return null;
}

function rangesOverlap(s1, e1, s2, e2) {
    return s1 < e2 && s2 < e1;
}

/**
 * Returns an error message string if invalid, or null if the slot is OK.
 * @param {Array} existingSlots - slots already added for this date (client-side list)
 */
export function validateSlotClient({ startTime, endTime, openTime, closeTime, existingSlots = [] }) {
    const start = toMinutes(startTime);
    const end = toMinutes(endTime);

    if (start === null || end === null) {
        return 'Please enter both a start and end time.';
    }
    if (start >= end) {
        return 'Start time must be before end time.';
    }
    if (openTime && closeTime) {
        const open = toMinutes(openTime);
        const close = toMinutes(closeTime);
        if (open !== null && close !== null && (start < open || end > close)) {
            return `Slot must be within operating hours (${openTime} - ${closeTime}).`;
        }
    }
    for (const slot of existingSlots) {
        const existingStart = toMinutes(slot.startTime);
        const existingEnd = toMinutes(slot.endTime);
        if (rangesOverlap(start, end, existingStart, existingEnd)) {
            return `This overlaps with an existing slot (${slot.startTime} - ${slot.endTime}).`;
        }
    }
    return null;
}
